import React, {useContext, useEffect, useState} from 'react'
import {useHistory} from 'react-router-dom'
import '../css/components/OptionsMenu.css'

import {BackgroundMusicContext} from '../context/BackgroundMusicContext'
import {UnmountContextProvider, UnmountContext} from '../context/UnmountContext'
import useTogglePopUp from '../hooks/useTogglePopUp'
import useAuthentication from '../hooks/useAuthentication'

import InfoPopUp from '../components/InfoPopUp'
import MusicAttribution from './MusicAttribution'
function OptionsMenu() {
    const [userLoggedOut, setUserLoggedOut] = useState(false)
    const {isBackgroundPlaying, toggleMuteBackground} = useContext(BackgroundMusicContext)
    const {isPopUpOpen, togglePopUp} = useTogglePopUp()
    const {logOut} = useAuthentication()
    const {unmount} = useContext(UnmountContext)
    const route = useHistory()

    useEffect(() => {
        userLoggedOut && unmount.safe && route.push('/')
    }, [userLoggedOut, unmount, route]) 

    return (
        <div className='optionsMenu'>
            <h3>Menu</h3>
            <button 
                className='optionsMenu_btn' 
                onClick={() => toggleMuteBackground(prevState => !prevState)}
            >
                <i className={`fas ${isBackgroundPlaying ? 'fa-volume-mute' : 'fa-music'}`}></i> 
                <span> {isBackgroundPlaying ? 'Mute' : 'Play'} Music</span>
            </button>
            <button 
                className='optionsMenu_btn'
                onClick={() => {
                    logOut()
                    setUserLoggedOut(true)
                }}
            >
                <i className="fas fa-door-open"></i> 
                <span> {userLoggedOut ? 'Loading...' : 'Log Out'}</span>
            </button>
            <p className='optionsMenu_btn landing_creditsLink ' onClick={togglePopUp}><em>Music Attribution</em></p>
            
            <UnmountContextProvider>
                <InfoPopUp isPopUpOpen={isPopUpOpen} togglePopUp={togglePopUp}>
                    <MusicAttribution />
                </InfoPopUp>
            </UnmountContextProvider>
        </div>
    )
}

export default OptionsMenu